import environment from '~/platform/utilities/environment';

export const SUBMIT_URL = `${environment.API_URL}/meb_api/v0/forms_submit_claim`;

export const LETTER_URL = `${environment.API_URL}/meb_api/v0/forms_claim_letter?type=VetTec`;

export const TITLE = 'Apply for VET TEC 2.0';
export const SUBTITLE = 'VET TEC 2.0 program (VA Form 22-10297)';
export const FORM_TITLE = 'VET TEC 2.0 Program (VA Form 22-10297)';

export const OMB_NUMBER = '2900-0950';
export const OMB_EXP_DATE = '05/31/2029';
